
import { TranslationRecord } from '../../types';

export const reviews: TranslationRecord = {
  // Reviews Section
  title: 'What Our Guests Say',
  subtitle: 'Discover why guests choose Loena Luxury Suites for their Thessaloniki experience.',
  reviewsTitle: 'Guest Reviews',
  guestReviews: 'Guest Reviews',
  reviewsCount: 'Reviews',
  
  // Rating and stats
  overallRating: 'Overall Rating',
  basedOnReviews: 'Based on guest reviews',
  excellent: 'Excellent',
  veryGood: 'Very Good',
  good: 'Good',
  average: 'Average',
  poor: 'Poor',
  
  // Review categories
  cleanliness: 'Cleanliness',
  location: 'Location',
  service: 'Service',
  value: 'Value for Money',
  amenities: 'Amenities',
  comfort: 'Comfort',
  
  // Actions
  readMore: 'Read More',
  readLess: 'Read Less',
  writeReview: 'Write Review',
  allReviews: 'All Reviews',
  
  // Review metadata
  reviewedOn: 'Reviewed on',
  verifiedGuest: 'Verified Guest',
  stayedFor: 'Stayed for',
  nights: 'nights',
  
  // Review responses
  managementResponse: 'Management Response',
  thankYou: 'Thank you for your review!',
  
  // Call to Action
  readyToExperienceLoena: 'Ready to Experience Loena Luxury?',
  joinSatisfiedGuests: 'Join hundreds of satisfied guests who have made Loena their home in Thessaloniki.',
  bookYourStay: 'Book Your Stay',
  contactUs: 'Contact Us',
  
  // Additional keys needed
  suitesTitle: 'Luxury Suites',
  suitesSubtitle: 'Experience modern comfort in our thoughtfully designed 35m² suites, perfect for couples or small families.',
  locationTitle: 'Perfect City Center Location',
  locationSubtitle: 'Experience Thessaloniki from our prime location. Everything you need is within walking distance.',
};
